<template>
  <div>
    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> รายการบริการไอที</h1>
        <p>[{{ name }}] [{{ params }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">บริการไอทีทั้งหมด</h3>
            <!-- <p>
              <button type="button" class="btn btn-primary">
                <i class="fas fa-plus"></i> แจ้งบริการไอที
              </button>
            </p> -->
          </div>
          <div class="tile-body">
            <div class="row mb-3">
              <div class="col-md-4 offset-md-8">
                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  placeholder="🔍 ค้นหา หน่วยงาน / ผู้แจ้ง / IP / รายละเอียด"
                />
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="bg-light">
                  <tr>
                    <th>#</th>
                    <th>วันที่ เวลา</th>
                    <th>หน่วยงาน</th>
                    <th>รายละเอียด</th>
                    <th>ติดต่อ</th>
                    <th>สถานะ</th>
                    <th>จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in filteredRepairs"
                    :key="item.id"
                    :class="{
                      'table-warning': !item.confirm_at,
                      'table-info': item.status_id === 4,
                      'table-success': item.completed_at,
                    }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <span class="text-muted">วันที่ : </span>
                      <span> {{ item.created_at | formatDate }}</span>
                      <br />

                      <span class="text-muted">เวลา : </span>
                      <span> {{ item.created_at | formatTime }}</span>
                    </td>
                    <td>
                      <span class="text-muted">หน่วยงาน : </span>
                      <span v-if="item.department">
                        {{ item.department.department_name }}</span
                      >
                      <br />
                      <span class="text-muted">ผู้แจ้ง : </span>
                      <span> {{ item.end_user }}</span>
                    </td>
                    <td>
                      <span class="text-muted">ประเภท : </span>
                      <span v-if="item.type">{{ item.type.type_name }}</span>
                      <span v-if="item.ip_address">
                        <button
                          class="btn btn-link ml-2 m-0 p-0"
                          v-clipboard:copy="item.ip_address"
                          v-clipboard:success="onCopy"
                          title="คัดลอก"
                        >
                          <i class="fas fa-copy"></i> {{ item.ip_address }}
                        </button>
                      </span>
                      <br />
                      <br />
                      <span class="text-muted">รายละเอียด : </span>
                      <span>{{ item.description }}</span>

                      <br />
                      <span class="text-muted">ความเห็น : </span>
                      <span v-if="item.comment" class="text-danger">{{
                        item.comment
                      }}</span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <span class="text-muted">มือถือ : </span>
                      <span v-if="item.mobile">{{ item.mobile }}</span>
                      <span v-else>-</span>
                      <br />
                      <span class="text-muted">ติดต่อภายใน : </span>
                      <span>{{ item.tel }}</span>
                    </td>
                    <td>
                      <span class="text-muted">สถานะ : </span>

                      <span v-if="item.status">
                        {{ item.status.status_name }}
                      </span>

                      <br />
                      <span class="text-muted">ผู้รับผิดชอบ : </span>
                      <span v-if="item.user">{{ item.user.name }}</span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <div
                        class="btn-group btn-group-sm"
                        role="group"
                        aria-label="Basic mixed styles example"
                      >
                        <button
                          @click="confirm(item)"
                          v-if="!item.confirm_at"
                          type="button"
                          class="btn btn-danger"
                          title="รับงาน"
                        >
                          <i class="fas fa-exclamation-triangle"></i>
                        </button>
                        <span v-if="item.user">
                          <button
                            @click="complete(item)"
                            v-if="!item.completed_at && item.confirm_at"
                            :disabled="
                              item.user.id != user_id || item.completed_at
                            "
                            type="button"
                            class="btn btn-success"
                            title="ปิดงาน"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                        </span>
                        <!-- <button
                          @click="complete(item)"
                          v-if="!item.completed_at && item.confirm_at"
                          :disabled="item.completed_at"
                          type="button"
                          class="btn btn-success"
                          title="ปิดงาน"
                        >
                          <i class="fas fa-check"></i>
                        </button> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div v-else class="text-center">/* ไม่มีข้อมูลบริการ */</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairsService from "../services/repairs.service";
import moment from "moment";
import { EventBus } from "@/event-bus";
export default {
  computed: {
    filteredRepairs() {
      if (!this.search) {
        return this.repairs;
      }

      const keyword = this.search.toLowerCase();

      return this.repairs.filter((item) => {
        const department = item.department?.department_name || "";
        const user = item.end_user || "";
        const description = item.description || "";
        const ip = item.ip_address || "";

        return (
          department.toLowerCase().includes(keyword) ||
          user.toLowerCase().includes(keyword) ||
          description.toLowerCase().includes(keyword) ||
          ip.toLowerCase().includes(keyword)
        );
      });
    },
  },
  data() {
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    return {
      search: "",
      user_id: user.id || null,
      repairs: [],
      id: this.$route.params.id,
      name: this.$route.name,
      params: this.$route.params.id,
    };
  },
  methods: {
    statusBadge(status) {
      switch (status) {
        case 1:
          return "badge-secondary";

        case 2:
          return "badge-warning";

        case 3:
          return "badge-success";

        case 4:
          return "badge-info";

        default:
          return "badge-light";
      }
    },
    get(id) {
      this.$http
        .get(`/repairs/status/${id}`)
        .then((res) => {
          this.repairs = res.data.data;
        })
        .catch((err) => {});
    },
    confirm(item) {
      this.$swal
        .fire({
          title: "รับงาน!",
          text: "คุณต้องการรับงานนี้หรือไม่?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "ใช่ ยืนยัน!",
          cancelButtonText: "ปิด",
        })
        .then((result) => {
          if (!result.isConfirmed) return;

          const data = {
            ...item,
            confirm_at: moment().format("YYYY-MM-DD HH:mm:ss"),
            user_id: this.user_id,
            status_id: 4,
          };

          RepairsService.update(data.id, data).then(() => {
            this.showSuccess();
            EventBus.$emit("my-event-name");
            this.get(this.$route.params.id);
          });
        });
    },
    complete(data) {
      this.$swal
        .fire({
          title: "เสร็จสิ้นแล้ว!",
          text: "ดำเนินการเรียบร้อยแล้ว?",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ใช่ ยืนยัน!",
          cancelButtonText: "ปิด",
        })
        .then((result) => {
          if (result.isConfirmed) {
            const payload = { ...data };

            payload.completed_at = moment().format("YYYY-MM-DD HH:mm:ss");
            payload.user_id = this.user_id;
            payload.status_id = 3;

            RepairsService.update(payload.id, payload).then(() => {
              this.showSuccess();
              EventBus.$emit("my-event-name");
              this.get(this.$route.params.id);
            });
          }
        });
    },
  },
  watch: {
    $route(to) {
      this.get(to.params.id);
      this.params = to.params.id;

      const u = JSON.parse(localStorage.getItem("user") || "{}");
      this.user_id = u.id || null;
    },
  },
  created() {
    this.get(this.$route.params.id);
  },
};
</script>

<style>
</style>